export function index()
{
    return axios.get(route('api.manage.companies.companyUsers') + '?limit=999')
        .then(response => response.data);
}

export function store(data, include = [])
{
	if (include.length > 0) {
        include = include.join();
    }

    return axios.post(route('api.manage.companies.companyUsers') + '?include=' + include, data)
        .then(response => response.data);
}

export function show(companyUserId)
{
    return axios.get(route('api.manage.companyUsers.show', { companyUserId: companyUserId }));
}

export function update(companyUserId, data)
{
    return axios.patch(route('api.manage.companyUsers.update', { companyUserId: companyUserId }), data)
        .then(response => response.data);
}

export function destroy(companyUserId)
{
    return axios.delete(route('api.manage.companyUsers.destroy', { companyUserId: companyUserId }));
}
